export var CloudResourceAttachmentEventType;
(function (CloudResourceAttachmentEventType) {
    CloudResourceAttachmentEventType["ATTACHMENT_EVENT_TYPE_UNSPECIFIED"] = "UNSPECIFIED";
    CloudResourceAttachmentEventType["ATTACHMENT_EVENT_TYPE_ATTACH"] = "ATTACH";
    CloudResourceAttachmentEventType["ATTACHMENT_EVENT_TYPE_DETACH"] = "DETACH";
})(CloudResourceAttachmentEventType || (CloudResourceAttachmentEventType = {}));
